<script>
    import showdown from 'showdown'

    const vlgStrapiUrl = 'https://strapi.vlginvestimentos.com.br'
    let termsAndPolicies
    let title
    let html
    let loading = true

	const getData = async() => {
        termsAndPolicies = await fetch(`${vlgStrapiUrl}/terms-and-policies/4`).then(x => x.json())
        const converter = new showdown.Converter()
        html = converter.makeHtml(termsAndPolicies.content)
        title = termsAndPolicies.title
        loading = false
    }
    getData()
</script>

<section id="pg-privacy-policy">
    {#if loading}
        <div class="spin"></div>
    {:else}
        <h1><u> { title } </u></h1>
        <div class="content"> { @html html } </div>
    {/if}
</section>

<style lang="scss">
    @use "../styles/variables" as v;
    section {
        background-color: white;

        h1 {
            text-align: center;
            padding-bottom: 2rem;
        }

        :global(*), :global(*::after), :global(*::before) {
            margin: revert;
            padding: revert;
        }
    }
    @keyframes spinner {
        0% {
            transform: translate3d(-50%, -50%, 0) rotate(0deg);
        }
        100% {
            transform: translate3d(-50%, -50%, 0) rotate(360deg);
        }
    }
    .spin::before {
        animation: 1.5s linear infinite spinner;
        animation-play-state: inherit;
        border: solid 5px #cfd0d1;
        border-bottom-color: #444444;
        border-radius: 50%;
        content: "";
        height: 60px;
        width: 60px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        will-change: transform;
    }

    @media only screen and (min-width: v.$mobile-devices) {
        section {
            padding: 1rem;

            h1 {
                font-size: 1.5rem;
            }
        }
    }
    @media only screen and (min-width: v.$md-desktop-devices) {
        section {
            padding: 5rem 15rem;

            h1 {
                font-size: 4rem;
            }
        }
    }

</style>
